import { Link } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import { NAV } from "../components/AppShell";
import { PageHeader } from "../components/common";

export default function Menu() {
  const { user } = useAuth();
  return (
    <div>
      <PageHeader title="Menu" />
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
        {NAV[user.role].map((i) => (
          <Link key={i.to + i.label} to={i.to} className="fp-card flex flex-col gap-2 hover:border-[#036248]" data-testid={`menu-${i.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
            <i.icon size={22} className="text-[#036248]" />
            <span className="text-sm font-semibold">{i.label}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
